import { render, staticRenderFns } from "./AccountAccessAff.vue?vue&type=template&id=ef9a16c0&"
import script from "./AccountAccessAff.vue?vue&type=script&lang=js&"
export * from "./AccountAccessAff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports